// ✅ HomePage.tsx with Redux integration

import  { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../state/store";
import { loadProducts } from "../state/slices/productSlice";
import { loadCategories } from "../state/slices/categorySlice";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/Loading";
import BannerSlider from "../components/BannerSlider";
import Footer from "../components/footers";
import SearchResults from "./SearchResults";
import MainNavbar from "./MainNavbar";
import SubNavbar from "./SubNavbar";
import FeaturedProducts from "./FeaturedProducts";
import DiscountedProducts from "./DiscountedProducts";
import TopRatedProducts from "./TopRatedProducts";
import RewardBanner from "./RewardBanner";
import "./Home.css";

const HomePage = () => {
  const dispatch = useDispatch<AppDispatch>(); 
  const { currentUser } = useAuth();

  const [visibleCount, setVisibleCount] = useState(5);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showSubnav, setShowSubnav] = useState(false);

  const isLoggedIn = !!currentUser;
  const userId = currentUser?.id ?? "guest";

  const products = useSelector((state: RootState) => state.product.items);
  const categories = useSelector((state: RootState) => state.category.categories);
  const loading = useSelector((state: RootState) => state.product.loading || state.category.loading);

  useEffect(() => {
    dispatch(loadProducts());
    dispatch(loadCategories());
  }, [dispatch]);



  const showMore = () => setVisibleCount((prev) => prev + 5);

  if (loading) return <Loading />;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="app-banner modern-scroll">
        {/* <p>
          📱 For better experience, download our application –
          <a href="https://your-app-link.com" target="_blank" rel="noopener noreferrer">
            Click Here
          </a>
        </p> */}
      </div>

      <MainNavbar
        searchQuery={searchQuery}
        setSearchQuery={(text) => {
          setSearchQuery(text);
          setIsSearchModalOpen(!!text.trim());
        }}
        isLoggedIn={isLoggedIn}
        showSubnav={showSubnav}
        setShowSubnav={setShowSubnav}
        userId={userId}
      />

      <SubNavbar categories={categories} />
      <BannerSlider />

      {isSearchModalOpen && (
        <SearchResults
          query={searchQuery}
          products={products}
          onClose={() => {
            setIsSearchModalOpen(false);
            setSearchQuery("");
          }}
        />
      )}

      <FeaturedProducts
        products={products}
        visibleCount={visibleCount}
        showMore={showMore}
      />

      <RewardBanner />

      <div className="additional-sections">
        <DiscountedProducts products={products} />
        <TopRatedProducts products={products} />
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
